'use client';

/**
 * The blinking "invitation caret" the start screen shows over an empty,
 * unfocused composer.
 *
 * The keyframes are injected once per document (keyed by element id), not once
 * per composer instance — the start screen and an active chat can both be
 * mounted at the same time under chat tabs.
 */

import { useEffect } from 'react';

export const CARET_STYLE_ID = 'meridian-caret-blink-style';
const CARET_KEYFRAMES = `@keyframes meridianCaretBlink{0%,49%{opacity:1}50%,100%{opacity:0}}`;

export function useInviteCaretKeyframes(enabled: boolean): void {
  useEffect(() => {
    if (!enabled) return;
    if (typeof document === 'undefined') return;
    if (document.getElementById(CARET_STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = CARET_STYLE_ID;
    style.textContent = CARET_KEYFRAMES;
    document.head.appendChild(style);
  }, [enabled]);
}
